import { render } from "./EditAuxiliarNote.vue?vue&type=template&id=52bf98fb&scoped=true"
import script from "./EditAuxiliarNote.vue?vue&type=script&lang=js"
export * from "./EditAuxiliarNote.vue?vue&type=script&lang=js"

import "./EditAuxiliarNote.vue?vue&type=style&index=0&id=52bf98fb&lang=css"
import "./EditAuxiliarNote.vue?vue&type=style&index=1&id=52bf98fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bf98fb"]])

export default __exports__